import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=a97dbb5a&scoped=true&"
import script from "./SubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=a97dbb5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97dbb5a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/app/components/UI/UiInput.vue').default,UiInputWrapper: require('/app/components/UI/UiInputWrapper.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default})
